import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

export interface SiteInstances {
    id: string;
    tenantId: string;
    siteKey: string;
    name: string;
    createdAtUtc: Date;
    modifiedAtUtc: Date;
    userCount?: number;
}

interface SiteInstanceResponse {
    id?: string; Id?: string;
    tenantId?: string; TenantId?: string;
    siteKey?: string; SiteKey?: string;
    name?: string; Name?: string;
    createdAtUtc?: string; CreatedAtUtc?: string;
    modifiedAtUtc?: string; ModifiedAtUtc?: string;
    userCount?: number; UserCount?: number;
}

@Injectable({
    providedIn: 'root'
})

export class SitesService {
    private readonly http = inject(HttpClient);
    private readonly apiUrl = '/api/sites/instances/tenant';

    getInstances(): Observable<SiteInstances[]> {
        return this.http.post<SiteInstanceResponse[]>(this.apiUrl, {}).pipe(
            map(instances => instances.map(item => ({
                id: item.id || item.Id,
                tenantId: item.tenantId || item.TenantId,
                siteKey: item.siteKey || item.SiteKey,
                name: item.name || item.Name,
                createdAtUtc: new Date(item.createdAtUtc || item.CreatedAtUtc),
                modifiedAtUtc: new Date(item.modifiedAtUtc || item.ModifiedAtUtc),
                userCount: item.userCount ?? item.UserCount ?? undefined

            }) as SiteInstances)),
            catchError((error: HttpErrorResponse) =>
                throwError(() => new Error(
                    error.error?.message || 'Failed to fetch instances'
                ))
            )
        );
    }
}